import { looksLikeCredential } from './deploy/action-file-diff';

export type EditorContent = {
  /** What goes into the code editor; empty while the key is withheld. */
  code: string | undefined;
  /** True when the file holds a private key. */
  withheld: boolean;
  /** Plain-text message for the dialog, outside the editor; set only while withheld. */
  notice?: string;
  /** Read-only when the user is a viewer or the key is withheld. */
  viewOnly: boolean;
};

/**
 * What the Actions code editor is handed for a script's text, and the one
 * place the read-only decision is made: `viewOnly` is the viewer role OR a
 * withheld key, so Save cannot write the notice back over the key and the page
 * only spreads this result. A file that `looksLikeCredential` (one definition,
 * shared with the publish diff) gets empty `code` and the `notice` as text the
 * dialog renders outside the editor. Deleting or replacing the file does not go
 * through the editor and is unaffected. Limitation: the raw text still sits in
 * the page's React state (`fileData`); it is just never passed to the editor.
 */
export const resolveEditorContent = (
  text: string | undefined,
  notice: string,
  {
    isViewer,
    withholdKeys = true,
  }: {
    isViewer: boolean;
    /**
     * Bobcat's master flag (`bobcat-five-stage-nav`). Off, the page is
     * candidate's: the key is handed to the editor as before (DoD #2).
     */
    withholdKeys?: boolean;
  }
): EditorContent =>
  withholdKeys && text !== undefined && looksLikeCredential(text)
    ? { code: '', withheld: true, notice, viewOnly: true }
    : { code: text, withheld: false, viewOnly: isViewer };
